import moment from "moment";
import { OmitField } from "src/app/@shared/decorators/api-field.decorator";
import { ModelBase } from "../../abstract/model-base.model";
import { LoanDeferralMode } from "./loan-deferral-mode.model";
import { LoanEarlyRepaymentMode } from "./loan-early-repayment-mode.model";
import { LoanEventType } from "./loan-event-type.model";

export class LoanEvent extends ModelBase {

    static override CLASS_NAME: string = 'LoanEvent';

    private _amount!: number;
    private _comment!: string;
    private _earlyRepaymentMode!: LoanEarlyRepaymentMode;
    private _effectiveDate!: moment.Moment;
    private _eventType!: LoanEventType;
    private _isCancelable!: boolean;
    private _newRate!: number;
    private _penaltyAmount!: number;
    private _penaltyAmountOrg!: number;
    private _sequence!: number;
    private _suspensionMode!: LoanDeferralMode;
    private _suspensionMonths!: number;

    public get amount(): number {
        return this._amount;
    }

    public set amount(value: any) {
        this._setValue('_amount', value, 'float');
    }

    public get comment(): string {
        return this._comment;
    }

    public set comment(value: any) {
        this._setValue('_comment', value, 'string');
    }

    public get earlyRepaymentMode(): LoanEarlyRepaymentMode {
        return this._earlyRepaymentMode;
    }

    public set earlyRepaymentMode(value: any) {
        this._setValue('_earlyRepaymentMode', value, 'LoanEarlyRepaymentMode');
    }

    public get effectiveDate(): moment.Moment {
        return this._effectiveDate;
    }

    public set effectiveDate(value: any) {
        this._setValue('_effectiveDate', value, 'date');
    }

    public get eventType(): LoanEventType {
        return this._eventType;
    }

    public set eventType(value: any) {
        this._setValue('_eventType', value, 'LoanEventType');
    }

    @OmitField()
    public get isCancelable(): boolean {
        return this._isCancelable;
    }

    public set isCancelable(value: any) {
        this._setValue('_isCancelable', value, 'boolean');
    }

    public get newRate(): number {
        return this._newRate;
    }

    public set newRate(value: any) {
        this._setValue('_newRate', value, 'float');
    }

    public get penaltyAmount(): number {
        return this._penaltyAmount;
    }

    public set penaltyAmount(value: any) {
        this._setValue('_penaltyAmount', value, 'float');
    }

    @OmitField()
    public get penaltyAmountOrg(): number {
        return this._penaltyAmountOrg;
    }

    public set penaltyAmountOrg(value: any) {
        this._setValue('_penaltyAmountOrg', value, 'float');
    }

    @OmitField()
    public get sequence(): number {
        return this._sequence;
    }

    public set sequence(value: any) {
        this._setValue('_sequence', value, 'integer');
    }

    public get suspensionMode(): LoanDeferralMode {
        return this._suspensionMode;
    }

    public set suspensionMode(value: any) {
        this._setValue('_suspensionMode', value, 'LoanDeferralMode');
    }

    public get suspensionMonths(): number {
        return this._suspensionMonths;
    }

    public set suspensionMonths(value: any) {
        this._setValue('_suspensionMonths', value, 'integer');
    }

}
